// @ts-nocheck

import React, { useState } from 'react';
import {
  makeStyles,
  Theme,
  createStyles,
  Button,
  CircularProgress,
  Container,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  MenuItem,
  InputLabel,
  Select,
  FormControl
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useQuery } from '@apollo/client';
import { ListFilteredEvents, LIST_FILTERED_EVENTS_QUERY } from '../../api/eventLog';
import { LIST_THING_QUERY, ThingType } from '../../api/things';


const useStyles = makeStyles((theme) => ({
  text_yaxis: {
    dominantBaseline: 'central',
    textAlign: 'right',
    stroke: theme.palette.text.primary,
    fill: theme.palette.text.primary,
  },
  text_xaxis: {
    textAnchor: 'middle',
    stroke: theme.palette.text.primary,
    fill: theme.palette.text.primary,
  },
  svg_chart: {
    overflow: 'visible',
  },
  path: {
    stroke: theme.palette.text.primary,
    strokeWidth: '2px',
  },
  circle_ds1: {
    stroke: theme.palette.text.primary,
    fill: theme.palette.text.primary,
    r: '3px',
  },
  text_charttitle: {
    textAnchor: 'middle',
    fontSize: '20px',
    stroke: theme.palette.text.primary,
    fill: theme.palette.text.primary,
  },
  alertMargin: {
    marginTop: '5%',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    stroke: theme.palette.text.primary,
    fill: theme.palette.text.primary,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  }
}));

const monthStr = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"]
const dayStr = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"]

class TempData {
  constructor(data, cfgParam) {
    this.data = data
    this.cfgParam = cfgParam
  }

  eventList() {
    if (this.data.listFilteredEvents == undefined) {
      return []
    } else {
      return this.data.listFilteredEvents.filter(edate => ((edate.createdAt >= this.cfgParam.startDate) && (edate.createdAt < this.cfgParam.endDate)));
    }
  }

  get maxTemp() {
    const maxTemps = [45, 40, 35, 30, 25, 20, 15, 10, 5, 0];
    let tmp = this.eventList()
    let max = tmp.reduce((prevValue, event) => {
      if (event.properties.temperature > prevValue) {
        return event.properties.temperature
      } else {
        return prevValue
      }
    }, maxTemps[maxTemps.length - 1])
    //console.log("max: " + max)
    return maxTemps.reduce((prevValue, temp) => {
      if (temp <= max) {
        return prevValue
      } else {
        return temp
      }
    }, maxTemps[0])
  }

  get minTemp() {
    const minTemps = [-30, -25, -20, -15, -10, -5, 0, 5, 10, 15, 20, 25];
    let tmp = this.eventList()
    let min = tmp.reduce((prevValue, event) => {
      if (event.properties.temperature < prevValue) {
        return event.properties.temperature
      } else {
        return prevValue
      }
    }, minTemps[minTemps.length - 1])

    return minTemps.reduce((prevValue, temp) => {
      if (temp < min) {
        return temp
      } else {
        return prevValue
      }
    }, minTemps[0])
  }
  static extractTemp(event) {
    return event.properties.temperature
  }
  static extractTime(event) {
    return event.createdAt
  }
}


class myTimeClass extends Date {
  constructor() {
    if(arguments.length == 0) {
      super();
    } else {
      super(arguments[0].getTime());
    }
  }

  get beginOfDay() {
    let tmpTime = new myTimeClass(this)
    tmpTime.setHours(0, 0, 0, 0);
    return tmpTime;
  }
  get endOfDay() {
    let tmpTime = new myTimeClass(this)
    tmpTime.setHours(23, 59, 59, 0);
    return tmpTime;
  }
  get nextDay() {
    let tmpTime = new myTimeClass(this)
    tmpTime.setDate(tmpTime.getDate() + 1);
    return tmpTime;
  }
  get prevDay() {
    let tmpTime = new myTimeClass(this)
    tmpTime.setDate(tmpTime.getDate() - 1);
    return tmpTime;
  }

  get beginOfWeek() {
    let tmpTime = new myTimeClass(this);
    tmpTime.setHours(0, 0, 0, 0)
    tmpTime.setDate(tmpTime.getDate() - tmpTime.getDay());
    return tmpTime
  }
  get endOfWeek() {
    let tmpTime = new myTimeClass(this)
    tmpTime.setHours(23, 59, 59)
    tmpTime.setDate(tmpTime.getDate() - tmpTime.getDay() + 7);
    return tmpTime
  }
  get nextWeek() {
    let tmpTime = new myTimeClass(this)
    tmpTime.setDate(tmpTime.getDate() + 7);
    return tmpTime
  }
  get prevWeek() {
    let tmpTime = new myTimeClass(this)
    tmpTime.setDate(tmpTime.getDate() - 7);
    return tmpTime
  }

  get beginOfMonth() {
    let tmpTime = new myTimeClass(this);
    tmpTime.setHours(0, 0, 0, 0)
    tmpTime.setDate(1);
    return tmpTime
  }
  get endOfMonth() {
    let tmpTime = new myTimeClass(this);
    tmpTime.setMonth(tmpTime.getMonth() + 1);
    tmpTime.setDate(0);
    tmpTime.setHours(23, 59, 59, 0);
    return tmpTime;
  }
  get nextMonth() {
    let tmpTime = new myTimeClass(this);
    tmpTime.setMonth(tmpTime.getMonth() + 1);
    return tmpTime
  }
  get prevMonth() {
    let tmpTime = new myTimeClass(this);
    tmpTime.setMonth(tmpTime.getMonth() - 1);
    return tmpTime
  }

}

export default function Statistics() {

  const [selectedDate, handleDateChange] = useState(new Date());
  const [sensorName, handleSensorNameChange] = React.useState('1');
  const handleRoomChange = (event) => {
    handleSensorNameChange(event.target.value);
  };
  const [timeFrame, handleTimeFrameChange] = React.useState('Tag');
  const handleTimeChange = (event) => {
    handleTimeFrameChange(event.target.value);
  };

  function calcTimeFrames(timeFrame, beginDate) {
    let currentDate = new myTimeClass(beginDate);
    let startDate;
    let endDate;

    if (timeFrame == "Tag") {
      startDate = currentDate.beginOfDay;
      endDate = currentDate.beginOfDay.nextDay;
    } else if (timeFrame == "Woche") {
      startDate = currentDate.beginOfWeek;
      endDate = (new myTimeClass(currentDate.beginOfWeek)).nextWeek;
    } else if (timeFrame == "Monat") {
      startDate = currentDate.beginOfMonth;
      endDate = (new myTimeClass(currentDate.beginOfMonth)).nextMonth;
    } else if (timeFrame == "Jahr") {
      //adjust = -365
      console.log("problem")
    } else {
      console.log("problem")
    }

    return ({ startDate: startDate, endDate: endDate });
  }

  function myFormatDate(myDate) {
    return `${myDate.getFullYear()}-${monthStr[myDate.getMonth()]}-${dayStr[myDate.getDate()]}`
  }

  let myTime = new myTimeClass(selectedDate)
  let selectedTime = calcTimeFrames(timeFrame, selectedDate);
  
 
  //console.log("myTimeFormat Start: " + myFormatDate(selectedTime.startDate));
  //console.log("myTimeFormat Ende: " + myFormatDate(selectedTime.endDate));

  let cfgParam = {
    maxHeight: 550,
    maxWidth: 550,
    type: timeFrame,
    //thingId: "13b698c5-1260-4522-8599-0d6609eec1bb",
    //startDate: `${yesterday.getFullYear()}-${monthStr[yesterday.getMonth()]}-${yesterday.getDate()}`,
    //endDate: `${currentDate.getFullYear()}-${monthStr[currentDate.getMonth()]}-${currentDate.getDate()}`,
    startDate: myFormatDate(selectedTime.startDate),
    endDate: myFormatDate(selectedTime.endDate),
    minTemp: 15,
    maxTemp: 30,
    chartTemps: [0, 5, 10, 15, 20, 25, 30],
    minYPx: 520,
    maxYPx: 100,

    minXPx: 0,
    maxXPx: 480,
  }

  const eventType = "TemperatureUpdate";
  const startTime = selectedTime.startDate
  const endTime = selectedTime.endDate
  //const startTime = cfgParam.startDate + "T00:00:00+02:00";
  //const endTime = cfgParam.endDate + "T00:00:00+02:00";


  const { loading: loadingThings, error: errorThings, data: dataThings } =
    useQuery<ListThingsData, undefined>(LIST_THING_QUERY);

  //if (dataThings) console.log(dataThings);

  const { loading: loadingEvents, error: errorEvents, data: dataEvents } =
    useQuery(LIST_FILTERED_EVENTS_QUERY, {
      variables: {
        thingId: dataThings?.listThings.filter(t => t.type === ThingType.TemperatureSensor)[sensorName].id,
        eventType,
        startTime,
        endTime
      },
      skip: !dataThings
    });




  //if (error) console.log(JSON.stringify(error));
  //if (data) console.log(data);
  //console.log(data?.ListFilteredEvents);

  function circProg() {
    return <div style={{ display: 'flex', justifyContent: 'center' }} className={classes.alertMargin}>
      <CircularProgress />
    </div>
  }

  function handleErr(message) {
    return <Alert
      severity="error"
      className={classes.alertMargin}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            console.log('refetching');
            window.location.reload(); // TODO only reload home component
          }}
        >
          Retry
        </Button>
      }
    >
      <AlertTitle>Error</AlertTitle>
      {message}
    </Alert >
  }


  function handleEvt() {
    let rooms = dataThings?.listThings.filter(t => t.type === ThingType.TemperatureSensor)
    if (!rooms) {
      rooms = []
    }

    let data = new TempData(dataEvents, cfgParam)
    cfgParam.minTemp = data.minTemp
    //console.log("minTemp: " + cfgParam.minTemp)
    cfgParam.maxTemp = data.maxTemp
    //console.log("maxTemp: " + cfgParam.maxTemp)
    cfgParam.name = dataThings?.listThings.filter(t => t.type === ThingType.TemperatureSensor)[sensorName].name
    return <div>
      
      <FormControl className={classes.formControl}>
        <InputLabel id="select-room-name-label">room name</InputLabel>
        <Select
          labelId="select-room-name-label"
          id="select-room-name"
          value={sensorName}
          onChange={handleRoomChange}
        >
          {rooms.map((room, index) => (
            <MenuItem key={room.id} value={index}>
              {room.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel id="select-time-frame-label">time frame</InputLabel>
        <Select
          labelId="select-time-frame-label"
          id="select-time-frame"
          value={timeFrame}
          onChange={handleTimeChange}
        >
          {["Tag", "Woche", "Monat", "Jahr"].map((myTime, index) => (
            <MenuItem key={myTime} value={myTime}>
              {myTime}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <br />
      <MuiPickersUtilsProvider utils={DateFnsUtils} >
        <DatePicker value={selectedDate} onChange={handleDateChange} variant="inline" disableToolbar />
      </MuiPickersUtilsProvider >
      <br />
      <svg id="mychart" width="600" height="600">
        <svg className={classes.svg_chart} x="50" y="0" width="550" height="550" viewBox="0 0 550 550">
          <MyChart cfgParam={cfgParam} data={data} />
        </svg>
      </svg>
    </div>
  }

  const classes = useStyles();
  return (
    <Container component="main" maxWidth="md" >
      {loadingEvents && circProg()}
      {errorEvents && handleErr(errorEvents.message)}
      {dataEvents && handleEvt()}
    </Container >
  )
}

class BaseChart {
  constructor(cfgParam, styleClass) {
    this.cfgParam = cfgParam;
    this.styleClass = styleClass;
  }
  drawCircles(cary) {
    return cary.map((evt) => {
      return <circle cx={this.toXPixel(new Date(TempData.extractTime(evt)))} cy={this.temp2y(TempData.extractTemp(evt))} className={this.styleClass.circle_ds1}>
        <title>{TempData.extractTime(evt)}: {TempData.extractTemp(evt)} Celsius</title>
      </circle>
    })
  }

  toXPixel(date) {
    let hours = date.getSeconds() / 60.0
    hours = (hours + date.getMinutes()) / 60.0
    hours = (hours + date.getHours())
    let result = this.cfgParam.minXPx - (hours - this.cfgParam.minTime) / (this.cfgParam.maxTime - this.cfgParam.minTime) * (this.cfgParam.minXPx - this.cfgParam.maxXPx)
    return result.toFixed(0)
  }


  temp2y(temp) {
    let result = this.cfgParam.minYPx - (temp - this.cfgParam.minTemp) / (this.cfgParam.maxTemp - this.cfgParam.minTemp) * (this.cfgParam.minYPx - this.cfgParam.maxYPx)
    return result.toFixed(0)
    //return (cfgParam.maxHeight - ((extractTemp(event) / 40.0) * cfgParam.maxHeight))
  }

  yStrokes() {
    var list = [];
    for (let i = this.cfgParam.minTemp; i <= this.cfgParam.maxTemp; i++) {
      list.push(i)
    }

    return list.map((i) =>
      <path className={this.styleClass.path} d={`M 0,${this.temp2y(i)} H 10`} />
    );
  }
  xaxis() {
    return <path className={this.styleClass.path} d={`M${this.cfgParam.minXPx} ${this.cfgParam.minYPx} h${this.cfgParam.maxXPx - this.cfgParam.minXPx}`} />
  }

  yaxis() {
    return <path className={this.styleClass.path} d={`M${this.cfgParam.minXPx} ${this.cfgParam.minYPx} v${this.cfgParam.maxYPx - this.cfgParam.minYPx}`} />
  }

  xStrokes() {
    var list = [];
    for (let i = this.cfgParam.minTime; i <= this.cfgParam.maxTime; i++) {
      list.push(i)
    }
    return list.map((i) => {
      let date;
      if (i == 24) {
        date = new Date(2020, 12, 1, 23, 59, 59);
      } else {
        date = new Date(2020, 12, 1, i, 0, 0);
      }
      return <path className={this.styleClass.path} d={`M${this.toXPixel(date)},${this.cfgParam.minYPx} v-10`} />
    }
    );
  }

  xAnnotate() {
    return [this.cfgParam.chartTimes.map((time) => {
      let date;
      if (time == 24) {
        date = new Date(2020, 12, 1, 23, 59, 59);
      } else {
        date = new Date(2020, 12, 1, time, 0, 0);
      }

      return <text className={this.styleClass.text_xaxis} x={this.toXPixel(date)} y={this.cfgParam.minYPx + 20}>{time}</text>

    }),
    <text x={this.cfgParam.maxXPx + 30} y={this.cfgParam.minYPx} className={this.styleClass.text_xaxis}>Zeit [h]</text>
    ]
  }

  yAnnotate() {
    return [this.cfgParam.chartTemps.map((temp) =>
      <text x="-25" y={this.temp2y(temp)} className={this.styleClass.text_yaxis}>{temp}</text>
    ),
    <text x="-25" y={this.cfgParam.maxYPx - 15} className={this.styleClass.text_yaxis}>Temperatur[°C]</text>
    ]
  }

  chartTitle() {
    return <text x={this.cfgParam.maxWidth / 2} y="40" className={this.styleClass.text_charttitle}>{this.cfgParam.name}: {this.cfgParam.startDate}</text>
  }

}

class DayTempChart extends BaseChart {
  constructor(cfgParam, styleClass) {
    super(cfgParam, styleClass);
    this.cfgParam.minTime = 0
    this.cfgParam.maxTime = 24
    this.cfgParam.chartTimes = [0, 3, 6, 9, 12, 15, 18, 21, 24]
  }

}

class WeekTempChart extends BaseChart {
  constructor(cfgParam, styleClass) {
    super(cfgParam, styleClass);
    this.cfgParam.minTime = 0
    this.cfgParam.maxTime = 7
    this.cfgParam.chartTimes = [0, 1, 2, 3, 4, 5, 6, 7]
  }

  xAnnotate() {
    let weekdays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
    let date = new myTimeClass().beginOfWeek.prevDay;
    return [this.cfgParam.chartTimes.map((dayidx) => {
      let dayname = weekdays[dayidx];
      date = date.nextDay;
      return <text className={this.styleClass.text_xaxis} x={this.toXPixel(date)} y={this.cfgParam.minYPx + 20}>{dayname}</text>
    }),
    <text x={this.cfgParam.maxXPx + 30} y={this.cfgParam.minYPx} className={this.styleClass.text_xaxis}>Zeit</text>
    ]
  }


  toXPixel(date) {
    let days = date.getSeconds() / 60.0
    days = (days + date.getMinutes()) / 60.0
    days = (days + date.getHours()) / 24.0
    days = days + date.getDay()
    //console.log("xxx date: " + date)
    //console.log("yyy days: " + days)
    let result = this.cfgParam.minXPx - (days - this.cfgParam.minTime) / (this.cfgParam.maxTime - this.cfgParam.minTime) * (this.cfgParam.minXPx - this.cfgParam.maxXPx)
    return result.toFixed(0)
  }

  xStrokes() {
    let date = new myTimeClass().beginOfWeek;
    var list = [];
    for (let i = this.cfgParam.minTime; i <= this.cfgParam.maxTime; i++) {
      list.push(i)
    }
    return list.map((i) => {
      date = date.nextDay;
      return <path className={this.styleClass.path} d={`M${this.toXPixel(date)},${this.cfgParam.minYPx} v-10`} />
    }
    );
  }
}

class MonthTempChart extends BaseChart {
  constructor(cfgParam, styleClass) {
    super(cfgParam, styleClass);
    this.cfgParam.minTime = 1
    this.cfgParam.maxTime = 32
    this.cfgParam.chartTimes = [1, 8, 15, 22, 29]
  }

  xAnnotate() {
    let date = new myTimeClass().beginOfMonth.prevWeek;
    return [this.cfgParam.chartTimes.map((weekidx) => {
      date = date.nextWeek;
      return <text className={this.styleClass.text_xaxis} x={this.toXPixel(date)} y={this.cfgParam.minYPx + 20}>{weekidx}</text>
    }),
    <text x={this.cfgParam.maxXPx + 30} y={this.cfgParam.minYPx} className={this.styleClass.text_xaxis}>Zeit</text>
    ]
  }


  toXPixel(date) {
    let days = date.getSeconds() / 60.0
    days = (days + date.getMinutes()) / 60.0
    days = (days + date.getHours()) / 24.0
    days = days + date.getDate()
    //console.log("xxx date: " + date)
    //console.log("yyy days: " + days)
    let result = this.cfgParam.minXPx - (days - this.cfgParam.minTime) / (this.cfgParam.maxTime - this.cfgParam.minTime) * (this.cfgParam.minXPx - this.cfgParam.maxXPx)
    return result.toFixed(0)
  }

  xStrokes() {
    let date = new myTimeClass(new Date(2020, 12, 1, 1, 0, 0, 0)).beginOfMonth.prevDay;
    var list = [];
    for (let i = this.cfgParam.minTime; i <= this.cfgParam.maxTime; i++) {
      list.push(i)
    }
    return list.map((i) => {
      date = date.nextDay;
      return <path className={this.styleClass.path} d={`M${this.toXPixel(date)},${this.cfgParam.minYPx} v-10`} />
    }
    );
  }
}


function MyChart({ cfgParam, data }) {

  const classes = useStyles();


  function addValues(chart) {
    let tary = data.eventList()
    //for (let evt of tary) { console.log(evt) }
    return chart.drawCircles(tary)
  }

  function initChart(chart) {
    // alert("ich bin hier 1")
    return [...chart.yAnnotate(), ...chart.xAnnotate(), ...chart.xStrokes(), ...chart.yStrokes(), chart.chartTitle(), chart.xaxis(), chart.yaxis()];
  }

  function init() {
    if (cfgParam.type == "Tag") {
      const chart = new DayTempChart(cfgParam, classes);
      return [...initChart(chart), ...addValues(chart)]
    }
    if (cfgParam.type == "Woche") {
      const chart = new WeekTempChart(cfgParam, classes);
      return [...initChart(chart), ...addValues(chart)]
    }
    if (cfgParam.type == "Monat") {
      const chart = new MonthTempChart(cfgParam, classes);
      return [...initChart(chart), ...addValues(chart)]
    }
  }

  return init();
}
